import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from 'swiper';
import { fetchNewest } from '../../../../redux/action/homePage/companies/newest';
import default_image_url from '../../../../redux/api/API';
import MainLoading from '../../../../utils/MainLoading';
import HomeSideTitle from '../../../homeTitle/HomeSideTitle';
SwiperCore.use([Pagination]);

const NewestCompanies = () => {
  const dispatch = useDispatch()
  const companies = useSelector(state => state.newest_companies)
  const {t} = useTranslation();

  useEffect(() => {
    if(!companies.newest.length) {
      dispatch(fetchNewest())
    }
  }, [])

  return (
    <div className='home_slider_wrapper'>
      {companies.loading ?
        <MainLoading />
      :
      companies.newest &&
        companies.newest.length ?
          <Container className='my-5'>
              <HomeSideTitle>{t("newest companies")}</HomeSideTitle>
              <div>
                <Swiper 
                  spaceBetween={20} 
                  pagination={{ "clickable": true }}
                  breakpoints={{
                    640: {
                      width: 640,
                      slidesPerView: 1,
                    },
                    900: {
                      width: 900,
                      slidesPerView: 2,
                    },
                    990: {
                      width: 990,
                      slidesPerView: 3,
                    },
                  }}
                  className="mySwiper">
                {companies.newest.map(company => (
                  <SwiperSlide key={company.id}>
                    <div className='home_company_wrapper'>
                      <div className='home_company_container'>
                        {company.avatar ?
                            <img src={default_image_url+company.avatar} alt="company" />
                        :
                            <img src='https://idc-drone.com/wp-content/plugins/woocommerce/assets/images/placeholder.png' alt="company" />
                        }
                        <div className='home_company_info'>
                          <h1>{company.title}</h1>
                          <div className='home_company_item'><h6>{t("location")} : </h6><h5>{company.province ? company.province+'، '+company.city : '-' }</h5></div>
                          <div className='home_company_footer'>
                              <div className='home_company_footer_item'><h5>{company.products_count} {t("product")}</h5></div>
                          </div>
                        </div>
                        <Link className='company_link' to={`/company/${company.id}`}>{t("visit company")}</Link>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Container>
        :
          ''
      }
    </div>
  )
}

export default NewestCompanies;

